<template>
    <div v-if="$slots.default" class="flex items-center gap-2" role="alert" :class="`message message-${variant} message-${severity}`">
        <template v-if="icon">
            <i :class="iconClasses"></i>
        </template>
        <slot />
    </div>
</template>

<script setup>
const props = defineProps({
    severity: {
        type: String,
        default: ''
    },
    variant: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: null
    },
    iconClasses: {
        type: String,
        default: ''
    }
})
</script>
